import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/operations/trips')({
  component: AdminTripsLayout,
});

function AdminTripsLayout() {
  return <Outlet />;
}
